<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-input v-model="query.name"
                              placeholder="请输入药房名称搜索"
                              suffix-icon="el-icon-search"
                              style="width: 282px;"
                              size="small">
                    </el-input>
                </div>
                <div>
                    <el-button type="primary" style="width: 124px" @click="openAdd">新增共享药房</el-button>
                </div>
            </div>
            <el-table :data="tableData"
                      v-loading="loading"
                      :header-cell-style="{'padding-left': '3%'}"
                      :cell-style="{'padding-left': '3%'}">
                <el-table-column prop="name" label="共享药房名称"></el-table-column>
                <el-table-column label="药房状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state == 1">已下架</span>
                        <span v-if="scope.row.state == 0">已上架</span>
                    </template>
                </el-table-column>
                <el-table-column label="开放状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lockLevel =='PUBLIC'">已开放</span>
                        <span v-if="scope.row.lockLevel =='LOCK_ONLY'">已屏蔽</span>
                    </template>
                </el-table-column>
                <el-table-column label="药房地址">
                    <template slot-scope="scope">
                        <span>{{ scope.row.province+scope.row.city+ scope.row.district+scope.row.detail}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="药房排序">
                    <template slot-scope="scope">
                        <span>{{ scope.row.rankingValue}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state == 0">
                            <el-button type="text" @click="onclickDown(scope.row)">下架</el-button>
                        </span>
                        <span v-if="scope.row.state == 1">
                            <el-button type="text" @click="onclickUp(scope.row)">上架</el-button>
                        </span>
                        <span v-if="scope.row.lockLevel =='PUBLIC'">
                            <el-button type="text" @click="onclickClose(scope.row)">屏蔽</el-button>
                        </span>
                        <span v-if="scope.row.lockLevel =='LOCK_ONLY'">
                            <el-button type="text" @click="onclickOpen(scope.row)">开放</el-button>
                        </span>
                        <span v-if="scope.row.userName == null">
                            <el-button type="text" @click="openUserSet(scope.row)">开通HIS</el-button>
                        </span>
                        <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
                        <el-button type="text" @click="openStock(scope.row)">管理库存</el-button>
                        <el-button type="text" @click="openFreight(scope.row)">运费模板</el-button>
                        <el-button type="text" @click="openDivided(scope.row)">提成设置</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增共享药房" :visible.sync="dialogAddVisible" width="800px" :close-on-click-modal="false"
                   :before-close="cancelAdd" :lock-scroll="true">
            <el-form :model="sharingPharmacyAdd" ref="add" :rules="rule" label-width="100px" size="small">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <el-form-item label="药房状态:">
                        <el-checkbox v-model="sharingPharmacyAdd.state" true-lable="0">上架</el-checkbox>

                        <el-checkbox v-model="sharingPharmacyAdd.lockLevel" true-lable="PUBLIC">开放</el-checkbox>

                    </el-form-item>

                    <el-form-item label="药房类别:" prop="typeCode">
                        <el-checkbox-group v-model="sharingPharmacyAdd.typeCode" @change="typeCodeChange">
                            <el-checkbox label="KE_LI">中药颗粒</el-checkbox>
                            <el-checkbox label="YING_PIAN">中药饮片</el-checkbox>
                            <el-checkbox label="GAO_FANG">中药膏方</el-checkbox>
                            <el-checkbox label="WAN_JI">中药丸剂</el-checkbox>
                            <el-checkbox label="PRODUCT_OTHER">产品及其他类</el-checkbox>
                        </el-checkbox-group>

                    </el-form-item>
                    <el-form-item label="药房名称:" prop="name">
                        <el-input v-model="sharingPharmacyAdd.name" style="width: 282px;"></el-input>
                    </el-form-item>
                    <el-form-item label="药房简述:" prop="description">
                        <el-input type="textarea" v-model="sharingPharmacyAdd.description"
                                  style="width: 282px;"></el-input>
                    </el-form-item>
                    <div class="dialog-set">
                        <el-form-item label="选择地址:" prop="provinceId">
                            <el-select v-model="sharingPharmacyAdd.provinceId" placeholder="选择省"
                                       @change="chooseProvince" style="width: 120px;">
                                <el-option v-for="item in province" :key="item.provinceId"
                                           :label="item.province" :value="item.provinceId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="cityId" label-width="0">
                            <el-select v-model="sharingPharmacyAdd.cityId" placeholder="选择市"
                                       @change="chooseCity" style="width: 120px">
                                <el-option v-for="item in city" :key="item.cityId"
                                           :label="item.city" :value="item.cityId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="areaId" label-width="0">
                            <el-select v-model="sharingPharmacyAdd.areaId" placeholder="选择区/县"
                                       style="width: 120px;">
                                <el-option v-for="item in area" :key="item.areaId"
                                           :label="item.area" :value="item.areaId"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item label="详细地址:" prop="detail">
                        <el-input v-model="sharingPharmacyAdd.detail" style="width: 282px"></el-input>
                    </el-form-item>
                    <el-form-item label="包邮金额:" prop="expressLine">
                        <el-input v-model="sharingPharmacyAdd.expressLine" style="width: 282px"></el-input>
                    </el-form-item>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>账号信息</span>
                    </div>
                    <el-form-item label="账号:" prop="userName">
                        <el-input v-model="sharingPharmacyAdd.userName" style="width: 282px"></el-input>
                    </el-form-item>
                    <el-form-item label="密码:" prop="password">
                        <el-input v-model="sharingPharmacyAdd.password" style="width: 282px"></el-input>
                    </el-form-item>
                </el-card>
                <div id="keSet" class="keSet" v-show="keShow">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>颗粒设置</span>
                        </div>
                        <el-form-item label="剂型药房描述:" prop="keDesc">
                            <el-input v-model="sharingPharmacyAdd.keDesc" style="width: 282px"></el-input>
                        </el-form-item>

                    </el-card>
                </div>
                <div id="frySet" class="frySet" v-show="fryShow">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>饮片设置</span>
                        </div>
                        <el-form-item label="代煎:" prop="isFry">
                            <el-radio-group v-model="sharingPharmacyAdd.isFry">
                              <el-radio :label="0">代煎</el-radio>
                              <el-radio :label="1">仅代煎</el-radio>
                              <el-radio :label="2">不代煎</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="代煎费:" prop="priceFry">
                            <el-input v-model="sharingPharmacyAdd.priceFry" style="width: 282px"/>
                            元/剂
                        </el-form-item>
                        <el-form-item label="剂型药房描述:" prop="yinDesc">
                            <el-input v-model="sharingPharmacyAdd.yinDesc" style="width: 282px"></el-input>
                        </el-form-item>

                    </el-card>
                </div>
                <div id="gaoSet" class="gaoSet" v-show="gaoShow">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>膏方设置</span>
                        </div>
                        <el-form-item label="最低制膏量:" prop="minMake">
                            <el-input v-model="sharingPharmacyAdd.minMake" style="width: 282px">g</el-input>
                        </el-form-item>
                        <el-form-item label="制膏费:" prop="priceMake">
                            <el-select size="small" placeholder="选择固定/不固定费用" style="width: 150px;margin-right: 20px"
                                       v-model="priceType" @change="choosePriceType">
                                <el-option label="固定" value="0"></el-option>
                                <el-option label="不固定" value="1"></el-option>
                            </el-select>

                            <el-input v-model="sharingPharmacyAdd.priceMake" style="width: 100px"/>
                            元
                        </el-form-item>
                        <el-form-item :hidden="makeMore">
                        <span>
                       <=<el-input v-model="sharingPharmacyAdd.makeStandard" style="width:60px"/>g,
                       <el-input v-model="sharingPharmacyAdd.priceMake" style="width: 100px"/>元,超出
                       <el-input v-model="sharingPharmacyAdd.priceMakeMore" style="width: 100px"/>g/元
                       </span>
                        </el-form-item>
                        <el-form-item label="剂型药房描述:" prop="gaoDesc">
                            <el-input v-model="sharingPharmacyAdd.gaoDesc" style="width: 282px"></el-input>
                        </el-form-item>

                    </el-card>
                </div>
                <div id="wanSet" class="wanSet" v-show="wanShow">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>丸剂设置</span>
                        </div>
                        <div class="tableDate">
                            <div class="button" style="width:3%;float:right;">
                                <P>
                                    <el-button class="el-icon-plus" @click.prevent="addRow()"></el-button>
                                </P>
                                <p>
                                    <el-button class="el-icon-minus" @click.prevent="delData()"></el-button>
                                </p>
                            </div>
                            <div class="table">
                                <el-table :data="wanjiData" ref="table" tooltip-effect="dark" border stripe
                                          style="width: 95%" @selection-change='selectRow'>
                                    <el-table-column type="selection" width="45" align="center"></el-table-column>
                                    <el-table-column label="序号" type="index" width="60" align="center" prop="rowNum">

                                    </el-table-column>
                                    <el-table-column label="剂型" align="center" prop="subType" width="200">
                                        <template slot-scope="scope">
                                            <el-select clearable v-model="scope.row.subType">
                                                <el-option label="水丸" value="SHUI_WAN"></el-option>
                                                <el-option label="水蜜丸" value="SHUI_MI_WAN"></el-option>
                                                <el-option label="浓缩水丸" value="NONG_SUO_SHUI_WAN"></el-option>
                                                <el-option label="浓缩蜜丸" value="NONG_SUO_MI_WAN"></el-option>
                                                <el-option label="蜜丸" value="MI_WAN"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="最低制丸量" align="center" prop="minMake" width="150">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.minMake"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="包装方式" align="center" prop="packageManner" width="200">
                                        <template slot-scope="scope">
                                            <el-select clearable v-model="scope.row.packageManner">
                                                <el-option label="袋装" value="袋装"></el-option>
                                                <el-option label="瓶装" value="瓶装"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>

                                </el-table>
                            </div>
                        </div>
                        <el-form-item label="制丸费:" prop="pricePill">
                            <el-select size="small" placeholder="选择固定/不固定费用" style="width: 150px;margin-right: 20px"
                                       v-model="pillType" @change="choosePillType">
                                <el-option label="固定" value="0"></el-option>
                                <el-option label="不固定" value="1"></el-option>
                            </el-select>

                            <el-input v-model="sharingPharmacyAdd.pricePill" style="width: 100px"/>
                            元
                        </el-form-item>
                        <el-form-item :hidden="pillMore">
                        <span>
                       <=<el-input v-model="sharingPharmacyAdd.freeStandard" style="width:60px"/>g,
                       <el-input v-model="sharingPharmacyAdd.pricePill" style="width: 100px"/>元,超出
                       <el-input v-model="sharingPharmacyAdd.pricePillMore" style="width: 100px"/>g/元
                       </span>
                        </el-form-item>
                        <el-form-item label="剂型药房描述:" prop="wanDesc">
                            <el-input v-model="sharingPharmacyAdd.wanDesc" style="width: 282px"></el-input>
                        </el-form-item>

                    </el-card>
                </div>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>其他设置</span>
                    </div>
                    <el-form-item label="包装方式:" prop="packageMethod">
                        <el-input v-model="sharingPharmacyAdd.packageMethod" style="width: 282px"></el-input>
                    </el-form-item>
                    <el-form-item label="药房排序:" prop="rankingValue">
                        <el-input v-model="sharingPharmacyAdd.rankingValue" style="width: 282px"></el-input>
                    </el-form-item>
                    <el-form-item label="药房介绍:" prop="pic">
                        <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="sharingPharmacyAdd.pic" class="course-img"
                                      :src="sharingPharmacyAdd.pic"></el-image>
                            <input type="file" class="upload-input" @change="addImg" accept="image/*" ref="picture"/>
                        </div>
                    </el-form-item>
                </el-card>
            </el-form>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="cancelAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑共享药房" :visible.sync="dialogEditVisible" width="800px" :close-on-click-modal="false"
                   :lock-scroll="true">
            <el-form :model="sharingPharmacyEdit" ref="edit" :rules="editRule" label-width="100px" size="small">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <el-form-item label="药房状态:">
                        <el-checkbox v-model="sharingPharmacyEdit.state" lable="0">上架</el-checkbox>

                        <el-checkbox v-model="sharingPharmacyEdit.lockLevel" lable="PUBLIC">开放</el-checkbox>

                    </el-form-item>

                    <el-form-item label="药房类别:" prop="typeCode">
                        <el-checkbox-group v-model="sharingPharmacyEdit.typeCode" @change="typeCodeChangeEdit">
                            <el-checkbox label="KE_LI">中药颗粒</el-checkbox>
                            <el-checkbox label="YING_PIAN">中药饮片</el-checkbox>
                            <el-checkbox label="GAO_FANG">中药膏方</el-checkbox>
                            <el-checkbox label="WAN_JI">中药丸剂</el-checkbox>
                            <el-checkbox label="PRODUCT_OTHER">产品及其他类</el-checkbox>
                        </el-checkbox-group>

                    </el-form-item>
                    <el-form-item label="药房名称:" prop="name">
                        <el-input v-model="sharingPharmacyEdit.name" style="width: 282px;"></el-input>
                    </el-form-item>
                    <el-form-item label="药房简述:" prop="description">
                        <el-input type="textarea" v-model="sharingPharmacyEdit.description"
                                  style="width: 282px;"></el-input>
                    </el-form-item>
                    <div class="dialog-set">
                        <el-form-item label="选择地址:" prop="provinceId">
                            <el-select v-model="sharingPharmacyEdit.provinceId" placeholder="选择省"
                                       @change="chooseProvince" style="width: 120px;">
                                <el-option v-for="item in province" :key="item.provinceId"
                                           :label="item.province" :value="item.provinceId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="cityId" label-width="0">
                            <el-select v-model="sharingPharmacyEdit.cityId" placeholder="选择市"
                                       @change="chooseCity" style="width: 120px">
                                <el-option v-for="item in city" :key="item.cityId"
                                           :label="item.city" :value="item.cityId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="areaId" label-width="0">
                            <el-select v-model="sharingPharmacyEdit.areaId" placeholder="选择区/县"
                                       style="width: 120px;">
                                <el-option v-for="item in area" :key="item.areaId"
                                           :label="item.area" :value="item.areaId"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item label="详细地址:" prop="detail">
                        <el-input v-model="sharingPharmacyEdit.detail" style="width: 282px"></el-input>
                    </el-form-item>
                    <el-form-item label="包邮金额:" prop="expressLine">
                        <el-input v-model="sharingPharmacyEdit.expressLine" style="width: 282px"></el-input>
                    </el-form-item>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>账号信息</span>
                    </div>
                    <el-form-item label="账号:" prop="userName">
                        <el-input v-model="sharingPharmacyEdit.userName" :disabled="true"
                                  style="width: 282px"></el-input>
                    </el-form-item>
                    <el-form-item label="密码:" prop="password">
                        <el-input v-model="sharingPharmacyEdit.password" style="width: 282px"></el-input>
                    </el-form-item>
                </el-card>

                <div id="keSet" class="keSet" v-show="keShow">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>颗粒设置</span>
                        </div>
                        <el-form-item label="剂型药房描述:" prop="keDesc">
                            <el-input v-model="sharingPharmacyEdit.keDesc" style="width: 282px"></el-input>
                        </el-form-item>

                    </el-card>
                </div>
                <div id="frySet" class="frySet" v-show="fryShow">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>饮片设置</span>
                        </div>
                      <el-form-item label="代煎:" prop="isFry">
                        <el-radio-group v-model="sharingPharmacyEdit.isFry">
                          <el-radio :label="0">代煎</el-radio>
                          <el-radio :label="1">仅代煎</el-radio>
                          <el-radio :label="2">不代煎</el-radio>
                        </el-radio-group>
                      </el-form-item>
                        <el-form-item label="代煎费:" prop="priceFry">
                            <el-input v-model="sharingPharmacyEdit.priceFry" style="width: 282px"/>
                            元/剂
                        </el-form-item>
                        <el-form-item label="剂型药房描述:" prop="yinDesc">
                            <el-input v-model="sharingPharmacyEdit.yinDesc" style="width: 282px"></el-input>
                        </el-form-item>

                    </el-card>
                </div>
                <div id="gaoSet" class="gaoSet" v-show="gaoShow">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>膏方设置</span>
                        </div>
                        <el-form-item label="最低制膏量:" prop="minMake">
                            <el-input v-model="sharingPharmacyEdit.minMake" style="width: 282px">g</el-input>
                        </el-form-item>
                        <el-form-item label="制膏费:" prop="priceMake">
                            <el-select size="small" placeholder="选择固定/不固定费用" style="width: 150px;margin-right: 20px"
                                       v-model="priceType" @change="choosePriceType">
                                <el-option label="固定" value="0"></el-option>
                                <el-option label="不固定" value="1"></el-option>
                            </el-select>

                            <el-input v-model="sharingPharmacyEdit.priceMake" style="width: 100px"/>
                            元
                        </el-form-item>
                        <el-form-item :hidden="makeMore">
                        <span>
                       <=<el-input v-model="sharingPharmacyEdit.makeStandard" style="width:60px"/>g,
                       <el-input v-model="sharingPharmacyEdit.priceMake" style="width: 100px"/>元,超出
                       <el-input v-model="sharingPharmacyEdit.priceMakeMore" style="width: 100px"/>g/元
                       </span>
                        </el-form-item>
                        <el-form-item label="剂型药房描述:" prop="gaoDesc">
                            <el-input v-model="sharingPharmacyEdit.gaoDesc" style="width: 282px"></el-input>
                        </el-form-item>

                    </el-card>
                </div>
                <div id="wanSet" class="wanSet" v-show="wanShow">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>丸剂设置</span>
                        </div>
                        <div class="tableDate">
                            <div class="button" style="width:3%;float:right;">
                                <P>
                                    <el-button class="el-icon-plus" @click.prevent="addRow()"></el-button>
                                </P>
                                <p>
                                    <el-button class="el-icon-minus" @click.prevent="delData()"></el-button>
                                </p>
                            </div>
                            <div class="table">
                                <el-table :data="wanjiData" ref="table" tooltip-effect="dark" border stripe
                                          style="width: 95%" @selection-change='selectRow'>
                                    <el-table-column type="selection" width="45" align="center"></el-table-column>
                                    <el-table-column label="序号" type="index" width="60" align="center" prop="rowNum">
                                    </el-table-column>
                                    <el-table-column label="剂型" align="center" prop="subType" width="200">
                                        <template slot-scope="scope">
                                            <el-select clearable v-model="scope.row.subType">
                                                <el-option label="水丸" value="SHUI_WAN"></el-option>
                                                <el-option label="水蜜丸" value="SHUI_MI_WAN"></el-option>
                                                <el-option label="浓缩水丸" value="NONG_SUO_SHUI_WAN"></el-option>
                                                <el-option label="浓缩蜜丸" value="NONG_SUO_MI_WAN"></el-option>
                                                <el-option label="蜜丸" value="MI_WAN"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="最低制丸量" align="center" prop="minMake" width="150">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.minMake"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="包装方式" align="center" prop="packageManner" width="200">

                                        <template slot-scope="scope">
                                            <el-select clearable v-model="scope.row.packageManner">
                                                <el-option label="袋装" value="袋装"></el-option>
                                                <el-option label="瓶装" value="瓶装"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>

                                </el-table>
                            </div>
                        </div>
                        <el-form-item label="制丸费:" prop="pricePill">
                            <el-select size="small" placeholder="选择固定/不固定费用" style="width: 150px;margin-right: 20px"
                                       v-model="pillType" @change="choosePillType">
                                <el-option label="固定" value="0"></el-option>
                                <el-option label="不固定" value="1"></el-option>
                            </el-select>

                            <el-input v-model="sharingPharmacyEdit.pricePill" style="width: 100px"/>
                            元
                        </el-form-item>
                        <el-form-item :hidden="pillMore">
                        <span>
                       <=<el-input v-model="sharingPharmacyEdit.freeStandard" style="width:60px"/>g,
                       <el-input v-model="sharingPharmacyEdit.pricePill" style="width: 100px"/>元,超出
                       <el-input v-model="sharingPharmacyEdit.pricePillMore" style="width: 100px"/>g/元
                       </span>
                        </el-form-item>
                        <el-form-item label="剂型药房描述:" prop="wanDesc">
                            <el-input v-model="sharingPharmacyEdit.wanDesc" style="width: 282px"></el-input>
                        </el-form-item>

                    </el-card>
                </div>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>其他设置</span>
                    </div>
                    <el-form-item label="包装方式:" prop="packageMethod">
                        <el-input v-model="sharingPharmacyEdit.packageMethod" style="width: 282px"></el-input>
                    </el-form-item>
                    <el-form-item label="药房排序:" prop="rankingValue">
                        <el-input v-model="sharingPharmacyEdit.rankingValue" style="width: 282px"></el-input>
                    </el-form-item>
                    <el-form-item label="药房介绍:" prop="pic">
                        <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="sharingPharmacyEdit.pic" class="course-img"
                                      :src="sharingPharmacyEdit.pic"></el-image>
                            <input type="file" class="upload-input" @change="editImg" accept="image/*"
                                   ref="editPicture"/>
                        </div>
                    </el-form-item>
                </el-card>
            </el-form>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="dialogEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="运费模板" :visible.sync="dialogFreightVisible" width="560px" :close-on-click-modal="false">
            <el-button type="primary" @click="openFreightSet" style="width: 76px">批量设置</el-button>
            <el-table :data="postageData" v-loading="loading" @selection-change="changePostage">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="provinceName" label="配送区域"></el-table-column>
                <el-table-column prop="price" label="运费">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.price"></el-input>
                    </template>
                </el-table-column>

            </el-table>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="dialogFreightVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmFreight" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量设置" :visible.sync="dialogFreightSetVisible" width="560px" :close-on-click-modal="false">
            <el-form :model="freightSeEdit" :rules="rule" label-width="100px" size="small">
                <el-form-item label="运费:" prop="freight">
                    <el-input v-model="freightSeEdit.freight" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="dialogFreightSetVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmFreightSet" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="提成设置" :visible.sync="dialogDividedVisible" width="600px" :close-on-click-modal="false">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>提成设置</span>
                </div>
                <el-table :data="dividedData" v-loading="loading">

                    <el-table-column prop="typeName" label="剂型"></el-table-column>
                    <el-table-column prop="doctorPercent" label="医生提成">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.doctorPercent">%</el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="salePercent" label="业务员提成">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.salePercent">%</el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="managerPercent" label="经理提成">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.managerPercent">%</el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="chargePercent" label="主管提成">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.chargePercent">%</el-input>
                        </template>
                    </el-table-column>

                </el-table>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>医事服务费</span>
                </div>
                <div class="tableDate">
                    <div class="button" style="width:3%;float:right;">
                        <P>
                            <el-button class="el-icon-plus" @click.prevent="addAdjustRow()"></el-button>
                        </P>
                        <p>
                            <el-button class="el-icon-minus" @click.prevent="delAdjustData()"></el-button>
                        </p>
                    </div>
                    <div class="table">
                        <el-table :data="adjustData" ref="table" tooltip-effect="dark" border stripe style="width: 95%"
                                  @selection-change='selectAdjustRow'>
                            <el-table-column type="selection" width="45" align="center"></el-table-column>
                            <el-table-column label="序号" type="index" width="50" align="center" prop="rowNum">
                            </el-table-column>
                            <el-table-column label="类型" align="center" prop="type" width="150">
                                <template slot-scope="scope">
                                    <el-select clearable v-model="scope.row.type">
                                        <el-option label="提高" value="RAISE_PRICE"></el-option>
                                        <el-option label="免费" value="FREE_PRICE"></el-option>
                                        <el-option label="降低" value="CUT_PRICE"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="比例" align="center" prop="percent" width="120">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.percent"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="排序" align="center" prop="numOrder" width="120">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.numOrder"></el-input>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>
                </div>
            </el-card>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="dialogDividedVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmDivided" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="开通HIS账号" :visible.sync="dialogUserSetVisible" width="560px" :close-on-click-modal="false">
            <el-form :model="userSetEdit" label-width="100px" size="small">
                <el-form-item label="账号:" prop="userName">
                    <el-input v-model="userSetEdit.userName" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="密码:" prop="password">
                    <el-input v-model="userSetEdit.password" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="dialogUserSetVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmUserSet" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import Vue from 'vue'

    export default {
        data() {
            return {
                authorization: localStorage.getItem('authorization'),
                query: {
                    name: '',
                },
                loading: true,
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // 列表数据
                tableData: [],
                province: [],
                city: [],
                area: [],
                rule: {
                    name: [{required: true, message: '请输入共享药房名称', trigger: 'blur'}],
                    //typeCode: [{required: true, message: '请选择药房类别', trigger: 'blur'}],
                    provinceId: [{required: true, message: '请选择地区', trigger: 'blur'}],
                    expressLine: [{required: true, message: '请输入包邮金额', trigger: 'blur'}],
                    userName: [{required: true, message: '请输入账号信息', trigger: 'blur'}],
                    password: [{required: true, message: '请输入账号密码', trigger: 'blur'}],
                },
                dialogAddVisible: false,
                keShow: false,
                fryShow: false,
                gaoShow: false,
                wanShow: false,
                makeMore: true,
                priceType: '0',
                wanjiData: [],
                selectlistRow: [],
                pillType: '0',
                pillMore: true,
                picUrl: '',
                dialogVisible: false,
                sharingPharmacyAdd: {
                    state: '',
                    lockLevel: '',
                    typeCode: [],
                    name: '',
                    description: '',
                    provinceId: '',
                    cityId: '',
                    areaId: '',
                    detail: '',
                    expressLine: '100',
                    userName: '',
                    password: '',
                    keDesc: '',
                    fry: '0',
                  isFry: '0',
                    priceFry: '0',
                    yinDesc: '',
                    minMake: '',
                    pricePill: '',
                    makeStandard: '',
                    gaoDesc: '',
                    gaoInside: '',
                    gaoExternal: '',
                    priceMakeMore: '',
                    packageMethod: '20g/袋',
                    freeStandard: '',
                    pricePillMore: '',
                    wanDesc: '',
                },
                dialogFreightVisible: false,
                postageData: [],
                checkPostageData: [],
                dialogFreightSetVisible: false,
                freightSeEdit: {
                    freight: ''
                },
                dialogDividedVisible: false,
                dividedData: [],
                adjustData: [],
                selectAdjustListRow: [],
                pharmacyId: '',
                items: [],
                dialogEditVisible: false,
                editRule: {
                    name: [{required: true, message: '请输入共享药房名称', trigger: 'blur'}],
                    typeCode: [{required: true, message: '请选择药房类别', trigger: 'blur'}],
                    provinceId: [{required: true, message: '请选择地区', trigger: 'blur'}],
                    expressLine: [{required: true, message: '请输入包邮金额', trigger: 'blur'}],
                },

                sharingPharmacyEdit: {
                    id: '',
                    state: '',
                    lockLevel: '',
                    typeCode: [],
                    name: '',
                    description: '',
                    provinceId: '',
                    cityId: '',
                    areaId: '',
                    detail: '',
                    wanjiData: [],
                    expressLine: '100',
                    userName: '',
                    password: '',
                    keDesc: '',
                    fry: '0',
                  isFry: '0',
                    priceFry: '0',
                    yinDesc: '',
                    minMake: '',
                    packageManner: '',
                    pricePill: '',
                    makeStandard: '',
                    gaoDesc: '',
                    gaoInside: '',
                    gaoExternal: '',
                    priceMakeMore: '',
                    packageMethod: '20g/袋',
                    freeStandard: '',
                    pricePillMore: '',
                    wanDesc: '',
                },
                dialogUserSetVisible: false,
                userSetEdit: {
                    id: '',
                    userName: '',
                    password: '',
                }

            }

        },
        created() {
            this.getData()
        },
        methods: {
            // 获取列表
            getData() {
                this.loading = true
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    name: this.query.name
                }
                this.axios.post('/api-b/10008/100088', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then((res) => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                        } else {
                            this.tableData = []
                            this.$message.info('暂无数据')
                        }
                        this.total = res.data.data.total
                    } else {
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 分页导航
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            search() {
                this.getData();
            },
            // 获取省
            getProvince() {
                this.axios.get('/api-b/10028/100071', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.province = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 打开新增弹窗
            openAdd() {
                this.getProvince()
                this.dialogAddVisible = true
            },
            // 取消新增
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 选择省
            chooseProvince(val) {
                this.axios.get('/api-b/10028/100072?father=' + val, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.city = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 选择市
            chooseCity(val) {
                this.axios.get('/api-b/10028/100073?father=' + val, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.area = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            typeCodeChange(val) {
                var index = val.findIndex(item => item === "YING_PIAN")
                if (index >= 0) {
                    this.fryShow = true
                } else {
                    this.fryShow = false
                    this.sharingPharmacyAdd.priceFry = '',
                        this.sharingPharmacyAdd.fry = '',
                        this.sharingPharmacyAdd.yinDesc = ''

                }
                var k_index = val.findIndex(item => item === "KE_LI")
                if (k_index >= 0) {
                    this.keShow = true
                } else {
                    this.keShow = false
                    this.sharingPharmacyAdd.keDesc = ''

                }
                var g_index = val.findIndex(item => item === "GAO_FANG")
                if (g_index >= 0) {
                    this.gaoShow = true
                } else {
                    this.gaoShow = false
                    this.sharingPharmacyAdd.gaoDesc = ''

                }
                var w_index = val.findIndex(item => item === "WAN_JI")
                if (w_index >= 0) {
                    this.wanShow = true
                } else {
                    this.wanShow = false
                    this.sharingPharmacyAdd.wanDesc = ''

                }
            },
            choosePriceType(val) {
                if (val == 1) {
                    this.makeMore = false
                } else {
                    this.makeMore = true
                }

            },
            choosePillType(val) {
                if (val == 1) {
                    this.pillMore = false
                } else {
                    this.pillMore = true
                }

            },
            selectRow(val) {
                this.selectlistRow = val
            },
            // 增加行
            addRow() {
                var list = {
                    rowNum: '',
                    subType: this.subType,
                    minMake: this.minMake,
                    packageManner: this.packageManner
                }
                this.wanjiData.unshift(list)
            },
            // 删除方法
            // 删除选中行
            delData() {
                for (let i = 0; i < this.selectlistRow.length; i++) {
                    let val = this.selectlistRow
                    // 获取选中行的索引的方法
                    // 遍历表格中tableData数据和选中的val数据，比较它们的rowNum,相等则输出选中行的索引
                    // rowNum的作用主要是为了让每一行有一个唯一的数据，方便比较，可以根据个人的开发需求从后台传入特定的数据
                    val.forEach((val, index) => {
                        this.wanjiData.forEach((v, i) => {
                            if (val.rowNum === v.rowNum) {
                                // i 为选中的索引
                                this.wanjiData.splice(i, 1)
                            }
                        })
                    })
                }
                // 删除完数据之后清除勾选框
                // this.$refs.wanjiData.clearSelection()
            },
            handleRemove(file, fileList) {
            },
            handlePictureCardPreview(file) {
                this.picUrl = file.url;
                this.dialogVisible = true;
            },

            // 确认添加
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let list = []

                        let params = {
                            name: this.sharingPharmacyAdd.name,
                            expressLine: this.sharingPharmacyAdd.expressLine,
                            userName: this.sharingPharmacyAdd.userName,
                            password: this.sharingPharmacyAdd.password,
                        }
                        switch (true) {
                            case this.sharingPharmacyAdd.typeCode === '':
                                break
                            case this.sharingPharmacyAdd.provinceId === '':
                                break
                            case this.sharingPharmacyAdd.cityId === '':
                                params.provinceId = this.sharingPharmacyAdd.provinceId
                                break
                            case this.sharingPharmacyAdd.areaId === '':
                                params.provinceId = this.sharingPharmacyAdd.provinceId
                                params.cityId = this.sharingPharmacyAdd.cityId
                                break
                            default:
                                params.typeCode = this.sharingPharmacyAdd.typeCode
                                params.provinceId = this.sharingPharmacyAdd.provinceId
                                params.cityId = this.sharingPharmacyAdd.cityId
                                params.areaId = this.sharingPharmacyAdd.areaId
                        }
                        if (this.sharingPharmacyAdd.state != '') {
                            params.state = this.sharingPharmacyAdd.state
                        }
                        if (this.sharingPharmacyAdd.lockLevel != '') {
                            params.lockLevel = this.sharingPharmacyAdd.lockLevel
                        }

                        if (this.sharingPharmacyAdd.description !== '') {
                            params.description = this.sharingPharmacyAdd.description
                        }

                        if (this.sharingPharmacyAdd.detail !== '') {
                            params.detail = this.sharingPharmacyAdd.detail
                        }
                        if (this.sharingPharmacyAdd.fry !== '') {
                            params.fry = this.sharingPharmacyAdd.fry
                        }
                      if (this.sharingPharmacyAdd.isFry !== '') {
                        params.isFry = this.sharingPharmacyAdd.isFry
                        if(params.isFry===2){params.fry=0}else {
                          params.fry=1  }
                      }
                        if (this.sharingPharmacyAdd.priceFry !== '') {
                            params.priceFry = this.sharingPharmacyAdd.priceFry
                        }
                        if (this.sharingPharmacyAdd.minMake !== '') {
                            params.minMake = this.sharingPharmacyAdd.minMake
                        }
                        if (this.sharingPharmacyAdd.priceMake !== '') {
                            params.priceMake = this.sharingPharmacyAdd.priceMake
                        }
                        if (this.sharingPharmacyAdd.makeStandard !== '') {
                            params.makeStandard = this.sharingPharmacyAdd.makeStandard
                        }
                        if (this.sharingPharmacyAdd.priceMakeMore !== '') {
                            params.priceMakeMore = this.sharingPharmacyAdd.priceMakeMore
                        }

                        if (this.sharingPharmacyAdd.packageMethod !== '') {
                            params.packageMethod = this.sharingPharmacyAdd.packageMethod
                        }

                        params.dosageType = this.selectlistRow
                        if (this.sharingPharmacyAdd.pricePill !== '') {
                            params.pricePill = this.sharingPharmacyAdd.pricePill
                        }
                        if (this.sharingPharmacyAdd.freeStandard !== '') {
                            params.freeStandard = this.sharingPharmacyAdd.freeStandard
                        }
                        if (this.sharingPharmacyAdd.pricePillMore !== '') {
                            params.pricePillMore = this.sharingPharmacyAdd.pricePillMore
                        }
                        if (this.sharingPharmacyAdd.rankingValue !== '') {
                            params.rankingValue = this.sharingPharmacyAdd.rankingValue
                        }

                        if (this.sharingPharmacyAdd.keDesc !== '') {
                            params.keDesc = this.sharingPharmacyAdd.keDesc
                        }

                        if (this.sharingPharmacyAdd.yinDesc !== '') {
                            params.yinDesc = this.sharingPharmacyAdd.yinDesc
                        }


                        if (this.sharingPharmacyAdd.gaoDesc !== '') {
                            params.gaoDesc = this.sharingPharmacyAdd.gaoDesc
                        }

                        if (this.sharingPharmacyAdd.wanDesc !== '') {
                            params.wanDesc = this.sharingPharmacyAdd.wanDesc
                        }
                        if (this.sharingPharmacyAdd.pic != '') {
                            params.pic = this.sharingPharmacyAdd.pic
                        }

                        this.axios.post('/api-b/10008/100132', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()

                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })

            },
            //下架           
            onclickDown(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div', {class: 'message-box'}, [
                        h('div', {class: 'message-title-box'}, [
                            h('i', {class: 'el-icon-warning message-box-icon'}, ''),
                            h('span', {class: 'message-box-title'}, '确认要下架该药房吗？'),
                        ])
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = new FormData()
                    params.append('id', data.id);
                    params.append('state', '1');
                    this.axios.post('/api-b/10008/100090', params, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {
                    })
                })

            },
            onclickUp(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div', {class: 'message-box'}, [
                        h('div', {class: 'message-title-box'}, [
                            h('i', {class: 'el-icon-warning message-box-icon'}, ''),
                            h('span', {class: 'message-box-title'}, '确认要上架该药房吗？'),
                        ])
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = new FormData()
                    params.append('id', data.id);
                    params.append('state', '0');
                    this.axios.post('/api-b/10008/100090', params, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {
                    })
                })

            },
            onclickClose(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div', {class: 'message-box'}, [
                        h('div', {class: 'message-title-box'}, [
                            h('i', {class: 'el-icon-warning message-box-icon'}, ''),
                            h('span', {class: 'message-box-title'}, '确认要屏蔽该药房吗？'),
                        ])
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = new FormData()
                    params.append("id", data.id);
                    params.append('lockLevel', 'LOCK_ONLY')
                    this.axios.post('/api-b/10008/100090', params, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {
                    })
                })

            },
            onclickOpen(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div', {class: 'message-box'}, [
                        h('div', {class: 'message-title-box'}, [
                            h('i', {class: 'el-icon-warning message-box-icon'}, ''),
                            h('span', {class: 'message-box-title'}, '确认要开放该药房吗？'),
                        ])
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = new FormData()
                    params.append("id", data.id);
                    params.append('lockLevel', 'PUBLIC')
                    this.axios.post('/api-b/10008/100090', params, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {
                    })
                })

            },
            openFreight(data) {
                this.axios.get('/api-b/100200/100201/' + data.id, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogFreightVisible = true
                        this.postageData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },
            changePostage(val) {
                this.checkPostageData = val
            },
            confirmFreight() {
                let params = {
                    postages: this.postageData
                }
                this.axios.post('/api-b/100200/100202', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)

                        this.dialogFreightVisible = false
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            openFreightSet(data) {

                this.dialogFreightSetVisible = true
            },
            confirmFreightSet() {

                this.checkPostageData.map((i, index) => {
                    i.price = this.freightSeEdit.freight
                    Vue.set(this.checkPostageData, index, i)
                })
                this.dialogFreightSetVisible = false
            },
            openDivided(data) {
                this.axios.get('/api-b/10008/100139/' + data.id, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogDividedVisible = true
                        this.pharmacyId = data.id
                        this.dividedData = res.data.data.saleDivideds
                        this.adjustData = res.data.data.adjustRules
                    } else {
                        this.$message.error(res.data.message)
                    }
                })


            },
            selectAdjustRow(val) {
                this.selectAdjustListRow = val
            },
            // 增加行
            addAdjustRow() {
                var list = {
                    rowNum: '',
                    type: this.type,
                    percent: this.percent,
                    numOrder: this.numOrder
                }
                this.adjustData.unshift(list)
            },
            // 删除方法
            // 删除选中行
            delAdjustData() {
                for (let i = 0; i < this.selectAdjustListRow.length; i++) {
                    let val = this.selectAdjustListRow
                    // 获取选中行的索引的方法
                    // 遍历表格中tableData数据和选中的val数据，比较它们的rowNum,相等则输出选中行的索引
                    // rowNum的作用主要是为了让每一行有一个唯一的数据，方便比较，可以根据个人的开发需求从后台传入特定的数据
                    val.forEach((val, index) => {
                        this.adjustData.forEach((v, i) => {
                            if (val.rowNum === v.rowNum) {
                                // i 为选中的索引
                                this.adjustData.splice(i, 1)
                            }
                        })
                    })
                }
                // 删除完数据之后清除勾选框
                // this.$refs.wanjiData.clearSelection()
            },
            confirmDivided() {
                let params = {
                    pharmacyId: this.pharmacyId,
                    saleDivideds: this.dividedData,
                    adjusts: this.selectAdjustListRow

                }
                this.axios.post('/api-b/10008/100140', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)

                        this.dialogDividedVisible = false
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取共享药房详情
            openEdit(data) {
                this.axios.get('/api-b/10008/100136/' + data.id, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {

                        this.sharingPharmacyEdit = res.data.data
                        this.dialogEditVisible = true

                        this.getProvince()
                        switch (true) {
                            case this.sharingPharmacyEdit.provinceId === '0':
                                this.sharingPharmacyEdit.provinceId = ''
                                this.sharingPharmacyEdit.cityId = ''
                                this.sharingPharmacyEdit.areaId = ''
                                break
                            case this.sharingPharmacyEdit.cityId === '0':
                                this.sharingPharmacyEdit.provinceId = parseInt(this.sharingPharmacyEdit.provinceId)
                                this.chooseProvince(this.sharingPharmacyEdit.provinceId)
                                this.sharingPharmacyEdit.cityId = ''
                                this.sharingPharmacyEdit.areaId = ''
                                break
                            case this.sharingPharmacyEdit.areaId === '0':
                                this.sharingPharmacyEdit.provinceId = parseInt(this.sharingPharmacyEdit.provinceId)
                                this.sharingPharmacyEdit.cityId = parseInt(this.sharingPharmacyEdit.cityId)
                                this.chooseProvince(this.sharingPharmacyEdit.provinceId)
                                this.sharingPharmacyEdit.areaId = ''
                                this.chooseCity(this.sharingPharmacyEdit.cityId)
                                break
                            default:
                                this.sharingPharmacyEdit.provinceId = parseInt(this.sharingPharmacyEdit.province)
                                this.sharingPharmacyEdit.cityId = parseInt(this.sharingPharmacyEdit.city)
                                this.chooseProvince(this.sharingPharmacyEdit.province)
                                this.sharingPharmacyEdit.areaId = parseInt(this.sharingPharmacyEdit.district)
                                this.chooseCity(this.sharingPharmacyEdit.cityId)
                        }
                        this.typeCodeChangeEdit(this.sharingPharmacyEdit.typeCode)
                        if (this.sharingPharmacyEdit.dosageType == null) {
                            this.wanjiData = [];
                        } else {
                            this.wanjiData = this.sharingPharmacyEdit.dosageType
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            typeCodeChangeEdit(val) {
                var index = val.findIndex(item => item === "YING_PIAN")
                if (index >= 0) {
                    this.fryShow = true
                } else {
                    this.fryShow = false
                    this.sharingPharmacyEdit.priceFry = '',
                        this.sharingPharmacyEdit.fry = '',
                        this.sharingPharmacyEdit.yinDesc = ''

                }
                var k_index = val.findIndex(item => item === "KE_LI")
                if (k_index >= 0) {
                    this.keShow = true
                } else {
                    this.keShow = false
                    this.sharingPharmacyEdit.keDesc = ''

                }
                var g_index = val.findIndex(item => item === "GAO_FANG")
                if (g_index >= 0) {
                    this.gaoShow = true
                } else {
                    this.gaoShow = false
                    this.sharingPharmacyEdit.gaoDesc = ''

                }
                var w_index = val.findIndex(item => item === "WAN_JI")
                if (w_index >= 0) {
                    this.wanShow = true
                } else {
                    this.wanShow = false
                    this.sharingPharmacyEdit.wanDesc = ''

                }
            },
            confirmEdit() {
                this.$refs.edit.validate(valid => {
                    console.log(this.wanjiData)
                    if (valid) {
                        let list = []
                        let params = {
                            id: this.sharingPharmacyEdit.id,
                            name: this.sharingPharmacyEdit.name,
                            expressLine: this.sharingPharmacyEdit.expressLine,
                            userName: this.sharingPharmacyEdit.userName,
                            password: this.sharingPharmacyEdit.password,
                        }
                        switch (true) {
                            case this.sharingPharmacyEdit.typeCode === '':
                                break
                            case this.sharingPharmacyEdit.provinceId === '':
                                break
                            case this.sharingPharmacyEdit.cityId === '':
                                params.provinceId = this.sharingPharmacyEdit.provinceId
                                break
                            case this.sharingPharmacyEdit.areaId === '':
                                params.provinceId = this.sharingPharmacyEdit.provinceId
                                params.cityId = this.sharingPharmacyEdit.cityId
                                break
                            default:
                                params.typeCode = this.sharingPharmacyEdit.typeCode
                                params.provinceId = this.sharingPharmacyEdit.provinceId
                                params.cityId = this.sharingPharmacyEdit.cityId
                                params.areaId = this.sharingPharmacyEdit.areaId
                        }
                        if (this.sharingPharmacyEdit.state != '') {
                            params.state = this.sharingPharmacyEdit.state
                        }
                        if (this.sharingPharmacyEdit.lockLevel != '') {
                            params.lockLevel = this.sharingPharmacyEdit.lockLevel
                        }

                        if (this.sharingPharmacyEdit.description !== '') {
                            params.description = this.sharingPharmacyEdit.description
                        }

                        if (this.sharingPharmacyEdit.detail !== '') {
                            params.detail = this.sharingPharmacyEdit.detail
                        }
                        if (this.sharingPharmacyEdit.fry !== '') {
                            params.fry = this.sharingPharmacyEdit.fry
                        }
                      if (this.sharingPharmacyEdit.isFry !== '') {
                        params.isFry = this.sharingPharmacyEdit.isFry
                        if(params.isFry===2){params.fry=0}else {
                          params.fry=1  }
                      }
                        if (this.sharingPharmacyEdit.priceFry !== '') {
                            params.priceFry = this.sharingPharmacyEdit.priceFry
                        }
                        if (this.sharingPharmacyEdit.minMake !== '') {
                            params.minMake = this.sharingPharmacyEdit.minMake
                        }
                        if (this.sharingPharmacyEdit.priceMake !== '') {
                            params.priceMake = this.sharingPharmacyEdit.priceMake
                        }
                        if (this.sharingPharmacyEdit.makeStandard !== '') {
                            params.makeStandard = this.sharingPharmacyEdit.makeStandard
                        }
                        if (this.sharingPharmacyEdit.priceMakeMore !== '') {
                            params.priceMakeMore = this.sharingPharmacyEdit.priceMakeMore
                        }

                        if (this.sharingPharmacyEdit.packageMethod !== '') {
                            params.packageMethod = this.sharingPharmacyEdit.packageMethod
                        }

                        params.dosageType = this.wanjiData
                        if (this.sharingPharmacyEdit.pricePill !== '') {
                            params.pricePill = this.sharingPharmacyEdit.pricePill
                        }
                        if (this.sharingPharmacyEdit.freeStandard !== '') {
                            params.freeStandard = this.sharingPharmacyEdit.freeStandard
                        }
                        if (this.sharingPharmacyEdit.pricePillMore !== '') {
                            params.pricePillMore = this.sharingPharmacyEdit.pricePillMore
                        }
                        if (this.sharingPharmacyEdit.rankingValue !== '') {
                            params.rankingValue = this.sharingPharmacyEdit.rankingValue
                        }

                        if (this.sharingPharmacyEdit.keDesc !== '') {
                            params.keDesc = this.sharingPharmacyEdit.keDesc
                        }

                        if (this.sharingPharmacyEdit.yinDesc !== '') {
                            params.yinDesc = this.sharingPharmacyEdit.yinDesc
                        }


                        if (this.sharingPharmacyEdit.gaoDesc !== '') {
                            params.gaoDesc = this.sharingPharmacyEdit.gaoDesc
                        }

                        if (this.sharingPharmacyEdit.wanDesc !== '') {
                            params.wanDesc = this.sharingPharmacyEdit.wanDesc
                        }
                        if (this.sharingPharmacyEdit.pic != '') {
                            params.pic = this.sharingPharmacyEdit.pic
                        }

                        this.axios.post('/api-b/10008/100135', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.getData()
                                this.dialogEditVisible = false
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })

            },

            // 上传菜单logo
            uploadImg(data) {
                return new Promise(resolve => {
                    this.axios.post('/api-f/10027/100065', data, {
                        headers: {
                            Authorization: this.authorization,
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(res => {
                        resolve(res)
                    })
                })
            },
            addImg() {
                let inputDOM = this.$refs.picture;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file', file)
                params.append("pathPrefix", 'pharmacies')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.sharingPharmacyAdd.pic = res.data.data.fileUrl
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 修改图像
            editImg() {
                let inputDOM = this.$refs.editPicture;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file', file)
                params.append("pathPrefix", 'pharmacies')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.sharingPharmacyEdit.pic = res.data.data.fileUrl
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            openStock(data) {

                this.$router.push({
                    path: 'tabMaterialsStock',
                    //name: 'tabMaterials',
                    query: {
                        pharmacyId: data.id
                    }
                })

            },
            openUserSet(data) {
                this.dialogUserSetVisible = true
                this.userSetEdit.id = data.id
            },
            confirmUserSet() {
                let params = {
                    id: this.userSetEdit.id,
                    userName: this.userSetEdit.userName,
                    password: this.userSetEdit.password,

                }
                this.axios.post('/api-b/10008/100141', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)

                        this.dialogUserSetVisible = false
                    } else {
                        this.$message.error(res.data.message)
                    }
                })


            },
        },

        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep: true
            }
        },

    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }

    .delete-button {
        margin-left: 20px;
        color: rgba(255, 75, 75, 1) !important;
    }

    .delete-button:hover {
        color: rgba(255, 75, 75, 0.8) !important;
    }

    .delete-button:focus {
        color: rgba(215, 37, 41, 1) !important;
    }

    .dialog-set {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }

    .tag-box {
        width: 250px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }

    .push {
        color: rgba(238, 238, 238, 1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }

    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }

    .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>
